import { PackageService } from '@services/package.service';
import { Package, PackageList, PackageStatus, } from '@uipath/workflow-web-viewer';
import { map } from 'rxjs/operators';
import * as i0 from "@angular/core";
import * as i1 from "./package.service";
/**
 * Service for package viewer
 */
var NugetViewerService = /** @class */ (function () {
    function NugetViewerService(_packageService) {
        var _this = this;
        this._packageService = _packageService;
        /**
         * Fetches a collection of package viewer details for a specific package
         * @param packageName Package Id
         * @param pageNumber Package version
         * @param pageSize Number of items to fetch at once
         */
        this.fetchPackageVersions = function (packageName, pageNumber, pageSize) {
            var queryOptions = {
                top: pageSize,
                skip: pageSize * (pageNumber - 1),
            };
            return _this._packageService.getVersions(packageName, queryOptions).pipe(map(function (response) {
                var packageList = response.data.map(function (iPackage) {
                    return new Package(iPackage.id, iPackage.version, iPackage.description, iPackage.authors, iPackage.published.toLocaleDateString(), iPackage.releaseNotes, iPackage.isActive ? PackageStatus.Active : PackageStatus.InActive);
                });
                return new PackageList(packageList, response.total);
            }));
        };
        /**
         * Downloads a package file data as blob
         * @param packageName Package Id
         * @param packageVersion Package version
         */
        this.downloadPackage = function (packageName, packageVersion) {
            return _this._packageService.download(packageName + ':' + packageVersion)
                .pipe(map(function (buffer) {
                return new Blob([buffer]);
            }));
        };
    }
    NugetViewerService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function NugetViewerService_Factory() { return new NugetViewerService(i0.ɵɵinject(i1.PackageService)); }, token: NugetViewerService, providedIn: "root" });
    return NugetViewerService;
}());
export { NugetViewerService };
